import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MsalService } from '../sso/msal.service';
import { take, map, switchMap } from 'rxjs/operators';

@Injectable()
export class JwtRequestInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private msal: MsalService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // An SSO token is asked for per request rather than read from the session: MSAL hands back
    // the cached one until it is close to expiry and renews it silently after that, so a
    // long-lived tab never carries a dead token. A legacy session uses the token it was issued.
    const token$ =
      this.authService.isSso && this.msal.isSso()
        ? from(this.msal.token())
        : this.authService.currentUser$.pipe(
            take(1),
            map((user) => user?.token ?? null)
          );

    return token$.pipe(
      switchMap((token) =>
        next.handle(
          token
            ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
            : request
        )
      )
    );
  }
}
